export function sync() {
  // the website config is static and doesn't use glob config
  return [];
}
